const getMonthlyRate = (rate) => ((rate + 1) ** (1 / 12)) - 1;

export default getMonthlyRate;
